/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Image_Models_At_Least_OneInputs */



/**
* | output |
* | --- |
* | "At least one image model must be selected." |
*
* @param {Org_Image_Models_At_Least_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_image_models_at_least_one = /** @type {((inputs?: Org_Image_Models_At_Least_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Image_Models_At_Least_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestens ein Bildmodell muss ausgewählt sein.")
	return /** @type {LocalizedString} */ ("At least one image model must be selected.")
});